import isString from 'lodash/isString'
import { typesArray } from 'lib/action'

type ApiAction = import('types/api').ApiAction

type NextFn = (action: ApiAction) => unknown
type RequestTypeGroup = {
  REQUEST: string
  RECEIVE: string
  FAIL: string
}

const isRequestTypeGroup = (value: unknown): value is RequestTypeGroup => {
  if (value == null || typeof value !== 'object') {
    return false
  }
  const candidate = value as Partial<RequestTypeGroup>
  return typeof candidate.REQUEST === 'string' && typeof candidate.RECEIVE === 'string' && typeof candidate.FAIL === 'string'
}


export default () => (next: NextFn) => (action: ApiAction) => {
  if (isString(action.type)) {
    return next(action)
  }
  if (isRequestTypeGroup(action.type)) {
    action.types = typesArray(action.type)
    delete action.type
  }
  return next(action)
}
